"use client";

import { OpenFeatureProvider } from "@openfeature/react-sdk";

export function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <>
      <OpenFeatureProvider>{children}</OpenFeatureProvider>
    </>
  );
}
